import type { JobItem } from '@core/offers-types';

export type JobSkillsSummaryJob = Pick<JobItem, 'id' | 'title'>;

export type JobSkillSummaryUser = {
  id: number;
  name: string;
  hasAvatar: boolean;
  photoThumbUrl: string;
  initials: string;
};

export enum SkillDetailsStatus {
  AtRequiredLevel = 'at_required_level',
  AboveRequiredLevel = 'above_required_level',
  BelowRequiredLevel = 'below_required_level',
  NoEvaluated = 'no_evaluated',
  NoRequiredLevel = 'no_required_level',
}

export type SummaryRating = {
  scale: number;
  expectedProficiencyPosition: number | null;
  ratedProficiencyPosition: number | null;
  ratedProficiencyName: string | null;
  status?: SkillDetailsStatus;
};

export type ProficiencyRating = SummaryRating & {
  user: JobSkillSummaryUser;
};

export type SkillBase = {
  id: number;
  name: string;
};

export type SkillDetails = SkillBase & {
  status: SkillDetailsStatus;
  mixedTeamFeedback: boolean;
  summaryRating: SummaryRating;
  proficiencyRatings: ProficiencyRating[];
};

export type JobSkillsSummaryDetailsBasicInfo = {
  skillsCount: number;
  matchingSkillsCount: number;
  atRequiredLevelSkills: SkillBase[];
  aboveRequiredLevelSkills: SkillBase[];
  belowRequiredLevelSkills: SkillBase[];
  noEvaluatedSkills: SkillBase[];
  noRequiredLevelSkills: SkillBase[];
};

export type JobSkillsSummaryDetails = {
  job: JobSkillsSummaryJob | null;
  isHidden: boolean;
  interviewResultsCount: number;
  users: JobSkillSummaryUser[];
  positionGuid: string;
  summary: JobSkillsSummaryDetailsBasicInfo;
  skillsDetails: SkillDetails[] | null;
};
